import initScrollReveal, {
  bindScrollRevealReset,
} from "./components/scroll-reveal.js";
import initGlobalModal from "./components/global-modal.js";
import initServiceModal from "./components/service-modal.js";
import initCf7ModalResponse from "./components/cf7-modal-response.js";
import initNewsletterPopup from "./components/newsletter-popup.js";
import { bindNewsletterForms } from "./components/newsletter-form.js";

(function () {
  window.rocketInitScrollReveal = initScrollReveal;
  window.rocketBindNewsletterForms = bindNewsletterForms;

  document.addEventListener("DOMContentLoaded", function () {
    bindScrollRevealReset();
    initScrollReveal();
    initGlobalModal();
    initServiceModal();
    initCf7ModalResponse();
    bindNewsletterForms(document);
    initNewsletterPopup(document);
    window.addEventListener("load", () => {
      initNewsletterPopup(document);
    }, { passive: true });

    const header = document.querySelector(".header");

  if (!header) {
    return;
  }

  let resizeRaf = 0;
  let lastNarrow = window.matchMedia("(max-width: 1024px)").matches;

  const isPortfolioArchive = () =>
    document.body.classList.contains("post-type-archive-portfolio");

  const scrollThresholds = () => {
    if (isPortfolioArchive()) {
      return { on: 100, off: 24 };
    }

    const narrow = window.matchMedia("(max-width: 1024px)").matches;
    if (narrow !== lastNarrow) {
      lastNarrow = narrow;
    }
    if (narrow) {
      return { on: 96, off: 12 };
    }
    return { on: 56, off: 10 };
  };

  const getScrollY = () =>
    Math.max(0, window.scrollY || window.pageYOffset || 0);

  const getMaxScroll = () =>
    Math.max(0, document.documentElement.scrollHeight - window.innerHeight);

  const syncHtmlScrollClass = () => {
    document.documentElement.classList.toggle(
      "header-is-scrolled",
      header.classList.contains("is-scrolled"),
    );
  };

  const getEffectiveThresholds = () => {
    const { on: baseOn, off: baseOff } = scrollThresholds();
    const maxScroll = getMaxScroll();

    if (isPortfolioArchive()) {
      if (maxScroll < baseOn) {
        return { on: maxScroll + 1, off: 0 };
      }
      return { on: baseOn, off: baseOff };
    }

    if (maxScroll <= baseOn) {
      const adaptiveOn = Math.min(
        baseOn,
        Math.max(8, Math.round(maxScroll * 0.35)),
      );
      const adaptiveOff = Math.min(adaptiveOn, Math.max(2, adaptiveOn - 6));
      return { on: adaptiveOn, off: adaptiveOff };
    }
    return { on: baseOn, off: baseOff };
  };

  const applyScrolledState = (shouldBeScrolled) => {
    const isScrolled = header.classList.contains("is-scrolled");
    if (shouldBeScrolled === isScrolled) {
      return;
    }
    header.classList.toggle("is-scrolled", shouldBeScrolled);
    syncHtmlScrollClass();
  };

  const updateHeaderState = () => {
    const y = getScrollY();
    const { on: scrollOn, off: scrollOff } = getEffectiveThresholds();
    const isScrolled = header.classList.contains("is-scrolled");

    if (isScrolled) {
      if (y < scrollOff) {
        applyScrolledState(false);
      }
      return;
    }

    if (y > scrollOn) {
      applyScrolledState(true);
    }
  };

  const scheduleResizeUpdate = () => {
    if (resizeRaf) {
      return;
    }
    resizeRaf = requestAnimationFrame(() => {
      resizeRaf = 0;
      updateHeaderState();
    });
  };

  syncHtmlScrollClass();
  updateHeaderState();
  window.addEventListener("scroll", updateHeaderState, { passive: true });
  window.addEventListener("resize", scheduleResizeUpdate, { passive: true });
  window.addEventListener("load", updateHeaderState, { passive: true });
  window.addEventListener("pageshow", updateHeaderState, { passive: true });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(updateHeaderState);
  }

  const wpmlLinks = header.querySelectorAll(".header__lang-switcher a[title]");
  wpmlLinks.forEach((link) => {
    link.removeAttribute("title");
  });

  const mobileToggle = header.querySelector(".mobile-toggle");
  const mobileMenu = header.querySelector("#mobile-main-menu");

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener("click", () => {
      const isOpen = header.classList.toggle("is-mobile-open");
      mobileToggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
      document.body.classList.toggle("mobile-menu-open", isOpen);
      updateHeaderState();
    });

    const mobileParentLinks = mobileMenu.querySelectorAll(
      ".menu-item-has-children > .menu-link, .has-children > .menu-link",
    );
    mobileParentLinks.forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();
        const parent = link.closest(".menu-item");
        if (!parent) return;
        parent.classList.toggle("is-open");
      });
    });
  }
  });
})();
